export default __webpack_public_path__ + "static/article-5-things-you-need-to-have-before-you-consolidate-your-debt-00f237fcc47d9a871bbc424e2dfc1b68.jpg";